var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "activity-stage dolch-dynamite"
  }, [_c('div', {
    staticClass: "barrel-stage"
  }, [_vm.currentRound && _vm.currentSection === 'barrel' ? _c('div', {
    staticClass: "typing-stage"
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: step.answer + index,
      class: ("td-container step-" + index)
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0) : _vm._e(), _c('div', {
    ref: "sparkContainer",
    staticClass: "spark-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePaths.sparkPath
    }
  })]), _c('div', {
    ref: "fuseContainer",
    staticClass: "fuse-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePaths.fusePath
    }
  })]), _c('div', {
    staticClass: "barrel-container"
  }, [_c('div', {
    staticClass: "full-barrel"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePaths.barrelPath
    }
  })]), _c('div', {
    staticClass: "blow-up-barrel"
  }, [_c('img', {
    staticClass: "barrel-lid",
    attrs: {
      "src": _vm.imagePaths.barrelLidPath
    }
  }), _c('img', {
    attrs: {
      "src": _vm.imagePaths.barrelBlownUpPath
    }
  })])])]), _vm.currentRound && _vm.currentSection === 'fireworks' ? _c('div', {
    staticClass: "fireworks-stage"
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: step.answer + index,
      staticClass: "td-container"
    }, [_c('div', {
      staticClass: "gradient-overlay"
    }), _c('img', {
      attrs: {
        "src": _vm.fireworksImage
      }
    }), _c('blinking-cursor-text', {
      class: ("type-line fireworks-step-" + index),
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0) : _vm._e()]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }